import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MarketingLayout } from "@/components/MarketingLayout";
import { Seo } from "@/components/Seo";
import { BookOpen } from "lucide-react";

export default function Academy() {
  const [data, setData] = useState({ articles: [], categories: [] });
  const [cat, setCat] = useState("");

  useEffect(() => {
    api.get("/academy").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const arts = data.articles.filter((a) => !cat || a.category === cat);

  return (
    <MarketingLayout>
      <Seo title="Academy" description="Learn trading basics, technical analysis, risk management and AI trading concepts." />
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <span className="text-xs font-semibold uppercase tracking-widest text-accent">Academy</span>
        <h1 className="mt-2 font-display text-3xl font-bold tracking-tight sm:text-4xl">Learn to trade with discipline</h1>
        <p className="mt-2 max-w-xl text-muted-foreground">Educational articles on indicators, risk management, psychology and how AI market analysis works.</p>

        <div className="mt-6 flex flex-wrap gap-2">
          <button onClick={() => setCat("")} className={`rounded-full px-4 py-1.5 text-sm ${!cat ? "bg-primary text-primary-foreground" : "border border-border text-muted-foreground"}`}>All</button>
          {data.categories.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`academy-cat-${c.replace(/\s/g, "-").toLowerCase()}`}
              className={`rounded-full px-4 py-1.5 text-sm ${cat === c ? "bg-primary text-primary-foreground" : "border border-border text-muted-foreground"}`}>{c}</button>
          ))}
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {arts.map((a) => (
            <Link key={a.slug} to={`/academy/${a.slug}`} data-testid={`academy-article-${a.slug}`}
              className="group rounded-2xl border border-border bg-card p-6 transition-colors hover:border-primary/40">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent/10"><BookOpen className="h-5 w-5 text-accent" /></div>
              <div className="mt-4 text-xs font-semibold uppercase tracking-wider text-muted-foreground">{a.category}</div>
              <h3 className="mt-1 font-display text-lg font-semibold group-hover:text-primary">{a.title}</h3>
              <p className="mt-1.5 text-sm text-muted-foreground">{a.excerpt}</p>
            </Link>
          ))}
        </div>
      </div>
    </MarketingLayout>
  );
}
